import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import SiteLogo from '../other/SiteLogo';
import { makeStyles } from 'tss-react/mui';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';

import { getAuth, onAuthStateChanged } from 'firebase/auth';
import mainStyle from '../../assets/mainStyle';

const useStyles = makeStyles()((theme) => {
  return({//
      colouredButton: {
        backgroundColor:"#19A78E",
        fontSize: "16px;",
        color: "#fff;",
        fontWeight: "700;",
        textDecoration: "none",
        padding: "13px;",
        borderRadius: "50px;",
        "&:hover":{
            backgroundColor:"#374657",
        }
      },

      clearButton: {
        fontSize: "16px;",
        color: "#374657;",
        fontWeight: "700;",
        textDecoration: "none"
      },
      Center:{
        textAlign: "center;"
      },
  root: {
    flexGrow: 1,
    zIndex: 1000,
    width: "100%"
  },
  Header: {
    backgroundColor: "#fff",
    backgroundImage: "url('/images/header-background.svg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    borderBottom: "1px solid #E6E6E6",
    paddingTop: "30px",
    paddingBottom: "20px",
    paddingRight: "20px",
    paddingLeft: "20px",
  },
  ToolBar: {
    padding: 0,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      display: 'block',
      textAlign: "center"
    },
  },
  title: {
    fontSize: 36,
    color: "#374657",
    fontWeight: 700,
    fontFamily: "'Titillium Web', sans-serif",
    marginRight: "20px",
  },
  Space: {
    flexGrow: 1,
  },
  Headermenu: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: "20px",
    },
  },
  MenuItem: {
    color: "#8f9297",
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      background: "none",
      color: "#555"
    }
  },
  MenuItemSelected: {
    color: "#000"
  }
})
});

const Header = () => {
  const { classes } = useStyles();
  const auth = getAuth();

  const [currentUser, setCurrentUser] = useState(null);
  const [subMenu, setSubMenu] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, [auth]);

  const handleSubMenuClick = (event) => {
    setSubMenu(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setSubMenu(null);
  };

  const navClass = ({ isActive }) =>
    isActive ? `${classes.MenuItem} ${classes.MenuItemSelected}` : classes.MenuItem;

  return (
    <div className={classes.root}>
      <header className={classes.Header}>
        <Toolbar className={classes.ToolBar}>
          <SiteLogo />
          <div className={classes.Space} />

          <div className={classes.Headermenu}>
            <Button component={NavLink} to="/" className={navClass}>
              Home
            </Button>

            {currentUser ? (
              <>
                <Button component={NavLink} to="/devices" className={navClass}>
                  Devices
                </Button>
                <Button onClick={handleSubMenuClick} className={classes.MenuItem}>
                  <MenuIcon />
                </Button>

                <Menu
                  id="subMenu"
                  anchorEl={subMenu}
                  open={Boolean(subMenu)}
                  onClose={handleSubMenuClose}
                >
                  <MenuItem component={Link} target="_blank" href="https://account.spried.com/" onClick={handleSubMenuClose}>Profile</MenuItem>
                  <MenuItem component={NavLink} to="/contact" onClick={handleSubMenuClose}>Contact</MenuItem>
                  <MenuItem component={NavLink} to="/documents" onClick={handleSubMenuClose}>Documents</MenuItem>
                  <Divider />
                  <MenuItem component={Link} href="https://spried.com" target="_blank" onClick={handleSubMenuClose}>SPRIED</MenuItem>
                  <MenuItem component={Link} href="https://feedback.spried.com/service/iot" target="_blank" onClick={handleSubMenuClose}>Feedback/Bug</MenuItem>
                  <Divider />
                  <MenuItem component={NavLink} to="/logout" onClick={handleSubMenuClose}>Logout</MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Button component={NavLink} to="/contact" className={navClass}>
                  Contact
                </Button>
                <Button component={NavLink} to="/documents" className={navClass}>
                  Documents
                </Button>
                <Button component={NavLink} to="/login" className={navClass}>
                  Login
                </Button>
              </>
            )}
          </div>
        </Toolbar>
      </header>
    </div>
  );
};

export default Header;
